import { Dispatch, SetStateAction } from "react";
import { ProductCardContainer, ProductCardImageSection, ProductCardTitle } from "./product-card.styles";
import Image from 'next/image';
import { ProductGroupedPolicy } from "modules/policies/types/policy.types";

export interface ProductCardProps {
    imageSrc?: string;
    product: ProductGroupedPolicy;
    selectedProduct: string;
    setSelectedProduct: Dispatch<SetStateAction<string>>;
}

export const ProductCard: React.FC<ProductCardProps> = ({ 
  product,
  selectedProduct,
  setSelectedProduct,
  imageSrc }) => {

    return (
      <ProductCardContainer 
        $isActive={product.salesProductName === selectedProduct} 
        onClick={() => setSelectedProduct(product.salesProductName)}>
        <ProductCardImageSection>
            {imageSrc && <Image src={imageSrc} alt="start-date" width="100" height="100" />}
        </ProductCardImageSection>
        <ProductCardTitle>{product.productLabel}</ProductCardTitle>
      </ProductCardContainer>
    );
  };